import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export type ExportFormat = 'pdf' | 'excel';

export interface ExportOptions {
  format: ExportFormat;
  limit: number | null;
}

@Component({
  selector: 'app-export-modal',
  templateUrl: './export-modal.component.html',
  styleUrls: ['./export-modal.component.scss'],
})
export class ExportModalComponent implements OnInit {
  @Input() format: ExportFormat | null = null;
  @Input() totalRecords: number = 0;
  @Input() hasFilters: boolean = false;
  @Input() showFormatSelection: boolean = false;
  @Output() confirm = new EventEmitter<ExportOptions>();

  selectedFormat: ExportFormat | null = null;
  selectedLimit: number | null = null;
  limitOptions: { value: number | null; label: string }[] = [];

  // Paso actual: 'format' o 'limit'
  currentStep: 'format' | 'limit' = 'limit';

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    // Si viene con formato preseleccionado, ir directo a selección de cantidad
    if (this.format && !this.showFormatSelection) {
      this.selectedFormat = this.format;
      this.currentStep = 'limit';
    } else {
      // Mostrar selección de formato primero
      this.currentStep = 'format';
    }

    this.buildOptions();

    if (this.limitOptions.length > 0) {
      this.selectedLimit = this.limitOptions[0].value;
    }
  }

  private buildOptions(): void {
    if (this.hasFilters) {
      this.limitOptions = [
        { value: null, label: `Todos los filtrados (${this.totalRecords})` },
        { value: 10, label: '10 registros' },
        { value: 50, label: '50 registros' },
        { value: 100, label: '100 registros' },
      ];
    } else {
      this.limitOptions = [
        { value: 10, label: '10 registros' },
        { value: 50, label: '50 registros' },
        { value: 100, label: '100 registros' },
        { value: 500, label: '500 registros' },
        { value: null, label: `Todos (${this.totalRecords})` },
      ];
    }
  }

  get formatLabel(): string {
    if (!this.selectedFormat) return 'Reporte';
    return this.selectedFormat === 'pdf' ? 'PDF' : 'Excel';
  }

  get formatIcon(): string {
    if (!this.selectedFormat) return 'fa-download';
    return this.selectedFormat === 'pdf' ? 'fa-file-pdf' : 'fa-file-excel';
  }

  get formatIconColor(): string {
    if (!this.selectedFormat) return '';
    return this.selectedFormat === 'pdf' ? 'text-danger' : 'text-success';
  }

  get modalTitle(): string {
    if (this.currentStep === 'format') {
      return 'Seleccionar formato';
    }
    return `Exportar a ${this.formatLabel}`;
  }

  getOptionHint(value: number | null): string {
    if (value === null) {
      return this.hasFilters ? 'Según filtros aplicados' : 'Puede tardar más';
    }
    return 'Más recientes';
  }

  selectFormat(format: ExportFormat): void {
    this.selectedFormat = format;
    this.currentStep = 'limit';
  }

  goBackToFormat(): void {
    this.currentStep = 'format';
  }

  onConfirm(): void {
    if (!this.selectedFormat) return;

    this.confirm.emit({
      format: this.selectedFormat,
      limit: this.selectedLimit,
    });
    this.activeModal.close();
  }

  onCancel(): void {
    this.activeModal.dismiss();
  }
}
